import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../images/1027.mp4'
import _imports_1 from '../images/gif6.gif'
import _imports_2 from '../images/pushs.png'
import _imports_3 from '../images/right.png'
import _imports_4 from '../images/mp4.mp4'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = { class: "ceshi" }
const _hoisted_4 = ["onMouseenter", "onMouseleave"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  src: _imports_2,
  alt: "手柄",
  class: "handle"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_11 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_12 = {
  key: 0,
  style: {"width":"50%","display":"flex","justify-content":"center","align-items":"center","height":"100%","margin-right":"30px"}
}
const _hoisted_13 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","height":"100%"}
}
const _hoisted_14 = {
  key: 2,
  class: "uls",
  style: {"flex":"1"}
}
const _hoisted_15 = { style: {"list-style":"none","color":"rgb(229,0,67)","font-size":"18px","margin-bottom":"10px","margin-left":"-15px"} }
const _hoisted_16 = {
  key: 0,
  style: {"list-style":"none","font-size":"18px","margin-bottom":"10px","margin-left":"-15px"}
}
const _hoisted_17 = {
  key: 0,
  style: {"margin-left":"18px"}
}
const _hoisted_18 = { style: {"margin-top":"50px"} }
const _hoisted_19 = {
  key: 1,
  style: {"margin-top":"30px","list-style":"none"}
}
const _hoisted_20 = {
  key: 1,
  style: {"display":"flex","margin-top":"30px"}
}
const _hoisted_21 = {
  key: 0,
  style: {"width":"50%","display":"flex","justify-content":"center","align-items":"center","height":"100%","margin-right":"30px"}
}
const _hoisted_22 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","height":"100%"}
}
const _hoisted_23 = {
  key: 2,
  class: "uls",
  style: {"flex":"1"}
}
const _hoisted_24 = { style: {"list-style":"none","color":"rgb(229,0,67)","font-size":"18px","margin-bottom":"10px","margin-left":"-15px"} }
const _hoisted_25 = {
  key: 0,
  style: {"margin-left":"18px"}
}
const _hoisted_26 = { style: {"margin-top":"50px"} }
const _hoisted_27 = {
  key: 0,
  style: {"margin-top":"30px","list-style":"none"}
}

import { ref, computed, reactive } from 'vue'
import wtc from '../images/WTC.png'
import p8 from '../images/p8.png'
import proPanel from '../images/ProPanel.png'
import bzd from '../images/bzd.png'
import bzds from '../images/bzds.png'
import car from '../images/car.png'
import DataPortal from '../images/DataPortal.png'
import EplanSmartWiring from '../images/EplanSmartWiring.png'
import ePOCKET from '../images/ePOCKET.png'
import pb from '../images/pb.png'
import PerforexLC from '../images/PerforexLC.png'
import PerforexMT from '../images/PerforexMT.png'
import pt from '../images/pt.png'
import sd from '../images/sd.png'
import RiPanel from '../images/RiPanel.png'
import Secarex from '../images/Secarex.png'
import cw from '../images/CW120.png'
import gj from '../images/gj.png'
import mp from '../images/mp4.mp4'
import RiMDC from '../images/RiMDC.png'
import VX25 from '../images/vx25.png'
import RiLineX from '../images/RiLineX.png'

// 控制 Dialog 显示的状态
interface Handle {
  name: string;
  top: string;
  left: string;
  offsetX?: string;
  offsetY?: string;
  fontX?: string;
  fontY?: string;
  hover: boolean;
  detail: object;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const dialogVisible = ref<boolean>(false)
// 记录当前点击的手柄索引
const currentHandleIndex = ref<number | null>(null)
// 弹框标题
const title = ref<string>('')
const srcList = ref([])
const srcLists = ref([])

const clickPlay = (url: string) => {
  console.log(url)
  window.open(url)
}
// 定义所有手柄的信息及位置信息（使用百分比定位）
const handles = reactive<Handle[]>([
  {
    top: '42%',
    left: '19%',
    name: 'RiPanel',
    offsetY: '-90%',
    offsetX: '-30%',
    fontX: '16%',
    fontY: '-266%',
    detail: {
      title: 'RiPanel威图配置系统',
      img: RiPanel,
      url: 'https://a.huiju.cool/p/e8063c',
      urls: '',
      list: [
        {
          name: '无需注册即可使用',
          children: [
            {
              name: '官网入口免费直达机柜配置系统，无需注册即可直接使用'
            }
          ]
        },
        {
          name: '快速可靠的配置',
          children: [
            {
              name: '快速、可靠地配置机柜和附件，节省大量设计时间'
            }
          ]
        },
        {
          name: '精准的设计辅助',
          children: [
            { name: '轻松规划开孔和钻孔，生成实时三维模型，并提供干涉碰撞提示' },
            { name: '在选择附件和加工设计时避免出错' },
          ]
        },
        {
          name: '灵活的文件处理',
          children: [
            { name: '可以灵活上传DWG/DWF格式的开孔图，并一键在机柜平板件上生成非标开孔' }
          ],
        },
        {
          name: '便捷的数据管理',
          children: [
            { name: '配置结束后自动生成项目ID号，方便储存和流转' },
            { name: '自动生成BOM清单、生产数据以及产品说明文档，简化项目规划' }
          ],
        },
        {
          name: '无缝的数据传输',
          children: [
            { name: '数据可以直接传输至Eplan Pro Panel' },
            { name: '通过与Eplan和威图配置软件的集成接口加快数据流转' }
          ],
        },
      ]
    }
  },
  {
    top: '19%',
    left: '12.5%',
    name: '精益化生产管理平台',
    offsetX: '-20%',
    offsetY: '-84%',
    fontX: '2%',
    fontY: '-255%',
    detail: {
      title: '',
      img: '',
      video: mp,
      url: '',
      urls: '',
      type: 0,
      list: []
    }
  },
  {
    top: '24%',
    left: '21%',
    name: 'P8',
    offsetY: '-90%',
    offsetX: '-44%',
    fontX: '2%',
    fontY: '-255%',
    detail: {
      title: 'Eplan Electric P8',
      img: p8,
      url: 'https://a.huiju.cool/p/aa6b78',
      urls: '',
      list: [
        {
          name: '数字化二维原理设计工具'
        },
        {
          name: '快速重用：宏变量技术，基于配置'
        },
        {
          name: '自动化设计方案: 从上游流程导入电气相关数据'
        },
        {
          name: '灵活: 面向图形亦面向对象'
        },
        {
          name: '快速: 高性能批量处理，自动化工具，自动检查工具，40+报表……'
        },
        {
          name: '在电气, 流体, 仪表与箱柜仿真间的跨学科的工程设计'
        },
      ]
    }
  },
  {
    top: '32%',
    left: '20.5%',
    name: 'Pro Panel',
    offsetY: '-92%',
    offsetX: '-28%',
    fontX: '4%',
    fontY: '-271%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Eplan Pro Panel',
      img: proPanel,
      url: 'https://a.huiju.cool/p/f64043',
      urls: '',
      list: [
        {
          name: '无缝获取 P8 数据进行2D/3D 机柜布局设计'
        },
        {
          name: '自动柜内布线'
        },
        {
          name: '完成机柜生产及工艺所需的5大类信息',
          children: [
            {
              name: '3D元器件摆放布局'
            },
            {
              name: '线缆的布线长度和走向'
            },
            {
              name: '钻孔NC数据（孔位置，孔加工方式（螺纹，攻丝）等）'
            },
            {
              name: '线缆加工信息（接线源和目标，线长，编号，压接线鼻子加工）'
            },
            {
              name: '软铜排设计信息'
            },
          ]
        },
        {
          name: '智能制造设备数据无缝集成',

        },
        {
          name: '三维可视化电气SOP作业指导'
        },
      ]
    }
  },
  {
    top: '33.9%',
    left: '8.6%',
    name: 'Data Portal',
    offsetY: '-90%',
    offsetX: '-25%',
    fontX: '-3%',
    fontY: '-268%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Eplan Data Portal',
      img: DataPortal,
      url: 'https://a.huiju.cool/p/081a9',
      urls: '',
      list: [
        {
          name: '可在线获取元器件制造商发布的高质量产品手册与设计数据'
        },
        {
          name: '与Eplan平台完全整合，通过拖拽的方式即可使用'
        },
        {
          name: '部件的查找和筛选功能简单易用'
        },
        {
          name: '部件包含安装尺寸数据、符号宏、图片、用户手册等',
          children: [
            {
              name: '接线图    （用于绘制原理图）'
            },
            {
              name: '外形图    （用于布置安装板）'
            },
            {
              name: '3D模型   （用于3D布局）'
            },
            {
              name: '工艺信息 （用于3D布线）'
            },
            {
              name: '钻孔样式 （用于手动或自动加工板材）'
            },
            {
              name: '产品文档'
            },
          ]
        },
        {
          name: '降低企业维护部件数据的成本'
        },
      ]
    }
  },
  {
    top: '48.9%',
    left: '4.6%',
    name: 'RiMDC微模块数据中心',
    offsetY: '-90%',
    offsetX: '-25%',
    fontX: '-3%',
    fontY: '-268%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'RiMDC微模块数据中心',
      subTitle: '威图的微模块解决方案是一种集成冷热通道、机柜、供配电、制冷、综合布线和监控管理等系统的模块化数据中心，可广泛应用于各类企业级数据中心、垂直行业用数据中心及大型数据中心，满足客户日益增长的大数据处理的业务需求。',
      img: RiMDC,
      url: 'https://a.huiju.cool/p/e28e9',
      urls: 'https://a.huiju.cool/p/29037',
      list: [
        {
          name: '精美 - 全模块子系统家族化设计风格，协调精美;'
        },
        {
          name: '至简 - 模块化预制化设计，积木式拼装，即插即用，无需过多额外施工;'
        },
        {
          name: '智能 - 电量、冷量、环境参数、资产智能化管理，提升资源利用率，节省运维成本;'
        },
        {
          name: '可靠 - 全系统安全设计及选型，保障整个微模块的可靠运行。'
        },
      ]
    }
  },
  {
    top: '32%',
    left: '39.5%',
    offsetY: '-92%',
    offsetX: '-26%',
    fontX: '4%',
    fontY: '-250%',
    name: '平板运输车',
    hover: false, // 添加 hover 状态
    detail: {
      title: '平板运输车',
      img: pb,
      url: '',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '八个存储格挡设计，高效存储、搬运机柜门板、安装板、侧板等平板件'
        },{
          name: '材料扎实耐用，可承重500公斤'
        },
        {
          name: '支撑杆高度可调，适应不同尺寸平板件'
        },
        {
          name: '带自锁功能的工业级转向轮，确保小车在车间内的可靠运行'
        },
        {
          name: '支架及底座均有涂层，防止机柜平板件（如门板和侧板等）刮擦或受损'
        },
      ]
    }
  },
  {
    top: '37.5%',
    left: '49.5%',
    name: 'Perforex MT机加工中心',
    offsetY: '-88%',
    offsetX: '-17%',
    fontX: '-8%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Perforex MT机加工中心',
      img: PerforexMT,
      url: 'https://a.huiju.cool/p/eb20e',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '机柜平板件和小箱体的全自动钻孔、攻丝和铣切加工'
        },
        {
          name: '加工过程全自动完成，无需人工干预，刀具自动检测校准'
        },
        {
          name: '易盼软件数据轻松导出，也可将数据转换为DXF格式或直接在机床上单机编程完成加工'
        },
        {
          name: '设备维护简单，使用成本低下'
        },
        {
          name: '有效缩短加工周期，保障客户交货周期'
        }, {
          name: '显著提升效率，提高加工质量'
        }, {
          name: '降低采购成本和运营成本，同时提高运营管理灵活性'
        },
      ]
    }
  },
  {
    top: '33%',
    left: '55%',
    name: 'Perforex LC激光加工中心',
    offsetY: '-86%',
    offsetX: '-16%',
    fontX: '-29%',
    fontY: '-177%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Perforex LC 激光加工中心',
      img: PerforexLC,
      url: 'https://a.huiju.cool/p/f8759',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '就不锈钢加工而言，或与Perforex BC相比，加工速度提高20倍'
        },
        {
          name: '无接触、低振动加工，刀具零磨损，低噪声'
        },
        {
          name: '3D加工，无需工件夹紧'
        },
        {
          name: '专为机柜行业开发，加工过程中对表面涂层无伤害'
        },
        {
          name: '可一次加工多个工件，减少搬运及操作时间'
        },
        {
          name: '短时间内提高产能，提升客户竞争力'
        },
        {
          name: '内置攻丝刀具，可完成攻丝作业'
        },
      ]
    }
  },
  {
    top: '39%',
    left: '69%',
    name: 'Secarex 剪切中心',
    offsetY: '-90%',
    offsetX: '-20%',
    fontX: '2%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Secarex 剪切中心',
      img: Secarex,
      url: 'https://a.huiju.cool/p/600475',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '优化的剪切工艺和激光精准定位确保极低的材料浪费'
        },
        {
          name: '避免了重复性测量和手动剪切带来的低效问题，节约时间'
        },
        {
          name: '符合人体工程学设计，操作安全舒适，降低工人疲劳感'
        },
        {
          name: '高品质工业刀具确保每一次剪切干净利落，提升加工质量'
        }, {
          name: '双手操作提供可靠的安全防护'
        }, {
          name: '与手动切割相比，显著节省时间'
        },
      ]
    }
  },
  {
    top: '31%',
    left: '79%',
    name: 'Manual Tools',
    offsetY: '-88%',
    offsetX: '-23%',
    fontX: '25%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: '手动工具',
      img: gj,
      url: '',
      urls: '',
      list: [
        {
          name: '针对电装车间的常见作业，提供从螺丝刀、电工剪，到剥线钳、压线钳，提供全套的手动工具'
        },{
          name: '所有螺丝刀手柄端头及柄身清晰标记型号，便于快速选择工具'
        },{
          name: '所有螺丝刀手柄端头及柄身清晰标记型号，便于快速选择工具'
        },{
          name: '液压开孔器配置多种刀模，可根据需要对不同材质进行不同尺寸和形状的冲孔'
        },{
          name: '符合人体工程学设计的操作手柄，工作时不会感到疲劳，并且防滑，提升作业舒适度'
        },
        {
          name: '德国品质，质量保证;'
        },

      ]
    }
  },
  {
    top: '37%',
    left: '83%',
    name: 'ePOCKET',
    offsetY: '-90%',
    offsetX: '-26%',
    fontX: '2%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'ePOCKET',
      img: ePOCKET,
      url: 'https://a.huiju.cool/p/7d1cc6',
      urls: '',
      list: [
        {
          name: '文件云端存储，避免损坏和丢失'
        },
        {
          name: '扫码即可随时获取当前项目信息'
        },  {
          name: '可以直接打开zw1图纸并标注，实现高效纠错'
        },
        {
          name: '提高运营管理&售后服务效率',
          children: [
            {
              name: '准确定位所需文档'
            },
            {
              name: '一键更新图纸文件'
            },
            {
              name: '清晰的文档上传/删除痕迹'
            },
          ]
        },
        {
          name: '专业工业软件服务',
          children: [
            {
              name: '合理的多级权限设置'
            },
            {
              name: '权威的平台安全认证'
            },
          ]
        },
      ]
    }
  },
  {
    top: '58%',
    left: '34.8%',
    name: 'WTC全自动线缆加工中心',
    offsetY: '-84%',
    offsetX: '-16%',
    fontX: '-3%',
    fontY: '-274%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'WT C 全自动线缆加工中心',
      img: wtc,
      url: 'https://a.huiju.cool/p/223c1',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '实现线径0.5 mm²至6mm²的线缆接线端头的全自动加工，整个加工过程无需人工干预'
        },
        {
          name: '可一次性加工24种或36种不同的线缆，按顺序或指令向制造系统输出线缆'
        },
        {
          name: '专利的压接模块免工具切换，可自动压接8-18mm的压接端头'
        },
        {
          name: '最多可配置10个振动筛，一次性投放10种压接端头'
        },
        {
          name: '从E-CAD工具到生产工序的端到端网络'
        },
        {
          name: '配合使用Eplan Smart Wiring软件工具，完成已加工线缆的接线工作'
        },
      ]
    }
  },
  {
    top: '61%',
    left: '41%',
    name: '半自动线缆设备',
    offsetY: '-90%',
    offsetX: '-22%',
    fontX: '6%',
    fontY: '-257%',
    hover: false, // 添加 hover 状态
    detail: {
      title: '半自动线缆设备',
      img: bzd,
      imgs: bzds,
      url: 'https://a.huiju.cool/p/66cf3',
      urls: '',
      list: [
        {
          name: '线缆加工按序定长切割'
        },
        {
          name: '人性化的操作'
        },
        {
          name: '进线辊轴保障轻松插入线缆'
        },
        {
          name: '气动或电动线缆加工'
        },
        {
          name: 'PC或CAE数据/EPLAN Pro Panel数据接口（取决于具体型号）'
        },
        {
          name: '触摸屏操作清晰简单'
        },

      ],
      lists: [
        {
          name: '安全、快速完成线缆压接'
        },
        {
          name: '自动换刀，节省时间'
        },
        {
          name: '自动检测线缆横截面积，自适应压接'
        },
        {
          name: '提高日常剥线和压线加工效率'
        },
        {
          name: '加工更快，重复作业精度更高，质量一致性有保障'
        },


      ]
    },
  },
  {
    top: '66%',
    left: '50%',
    name: '手动装配台',
    offsetY: '-90%',
    offsetX: '-26%',
    fontX: '-2%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: '手动装配台',
      img: sd,
      url: '',
      urls: 'https://a.huiju.cool/p/e4158',
      list: [
        {
          name: '为机柜装配和布线提供人体工学解决方案'
        },
        {
          name: '倾斜角度和高度可根据操作人员身高调节'
        },
        {
          name: '工件装夹简单，快速固定安装板或小箱体'
        },
        {
          name: '丰富多样的适配方案',
          children:[
            {name:"最宽可达1900mm"},
            {name:"安装板移动滚轮"},
            {name:"线卷支架"},
          ]
        },
        {
          name: '不使用时可折叠存放，占用空间极小'
        },
      ]
    }
  },
  {
    top: '59%',
    left: '52.5%',
    name: '接线小推车',
    offsetY: '-90%',
    offsetX: '-27%',
    fontX: '-12%',
    fontY: '-238%',
    hover: false, // 添加 hover 状态
    detail: {
      title: '接线小推车',
      img: car,
      url: '',
      urls: '',
      list: [
        {
          name: '可衔接WT全自动线缆加工中心，一次容纳8根来自WT的线缆收集轨槽'
        },
        {
          name: '配置单机支架，可装配PC单机安装智能布线软件'
        },
        {
          name: '一次性配齐单柜线缆，提升接线效率'
        },{
          name: '通过橡胶滚轮在车间移动，快速转运物料'
        },{
          name: '基于项目信息对下游流程进行拣选，支持下游布线接线流程'
        },{
          name: '配置工具支架，优化手动接线工作站'
        },
      ]
    }
  },
  {
    top: '60%',
    left: '58.5%',
    name: 'Eplan Smart Wiring',
    offsetY: '-90%',
    offsetX: '-20%',
    fontX: '-17%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'Eplan Smart Wiring',
      img: EplanSmartWiring,
      url: 'https://a.huiju.cool/p/cfec3',
      urls: '',
      list: [
        {
          name: '分步说明，无需查看原理图即可轻松装配布线'
        },
        {
          name: '从连接点到精确路由路径的所有必要信息都以数字格式提供，如果需要，还可以使用用三维格式展示'
        },
        {
          name: '显示的状态信息让不同员工之间进行项目交接时，可以轻松获知项目进度'
        },
        {
          name: '接线工作SOP管理，透明化、可追溯'
        },
        {
          name: '减少人力成本'
        },
      ]
    }
  },
  {
    top: '58%',
    left: '83%',
    name: 'CW 120-M 铜排加工中心',
    offsetY: '-88%',
    offsetX: '-17%',
    fontX: '-33%',
    fontY: '-255%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'CW 120-M 铜排加工中心',
      img: cw,
      url: 'https://a.huiju.cool/p/32609',
      urls: '',
      list: [
        {
          name: '用于铜排折弯、冲孔和裁切',
          children: [
            {
              name: '铜排裁切：定长裁切，无需人工测量'

            }, {
              name: '铜排冲孔：根据需求选择刀模'
            },
            {
              name: '铜排折弯，最大宽度120mm，厚度12mm'
            }
          ]
        },
        {
          name: '自带转向轮，可移动，操作灵活简便'
        },
        {
          name: '可随时移动至加工区，简单便捷'
        },
        {
          name: '采用 Ehrt 产品解决方案进行全自动铜排加工，实现与Eplan设计数据无缝链接'
        },
      ]
    }
  },
  {
    top: '54.9%',
    left: '70.6%',
    name: 'MCC柜',
    offsetY: '-90%',
    offsetX: '-25%',
    fontX: '-3%',
    fontY: '-268%',
    hover: false, // 添加 hover 状态
    detail: {
      title: 'VX25 Ri4Power',
      img: VX25,
      url: 'https://a.huiju.cool/p/e5c82',
      urls: 'https://a.huiju.cool/p/2b06a',
      list: [
        {
          name: '标准固定分隔式配电柜，配电柜内部分隔形式可满足Form1-4，最高分隔形式可做到Form4b'
        },
        {
          name: '标准防护等级高达IP54，更适用于恶劣的工业环境;可根据散热需求，配置风扇或降低防护等级至IP2X'
        },
        {
          name: '采用开放式平台，不对内部元件品牌进行限制，方便客户自由选用'
        },
        {
          name: '模块化结构保证了单元方案的选定及组装灵活方便。水平母线顶置、后置均可；结构尺寸可以个性化定制；出线方式侧出、后出，均可'
        },
        {
          name: '配电柜结合威图母线系统使用，标准50X10及30X10扁平铜排作为主母排，主母线最高可达6300A；母线连接采用不打孔连接的型式，生产高效易维护'
        },
        {
          name: '产品通过认证 IEC61439-1/-2, CCC; 并根据IEC61439标准要求，做过Design verification的相关测试，对于出口IEC标准的项目可以直接使用，免认证'
        },
      ]
    },
    detail2: {
      title: 'RiLineX 配电平台',
      img: RiLineX,
      url: 'https://a.huiju.cool/p/e1364b3',
      urls: 'https://a.huiju.cool/p/d6fb06',
      list: [
        {
          name: '新型的开放式配电平台，可应用在AC1000V和DC 1500V场合下，抗短路电流高达65kA，额定电流高达800A'
        },
        {
          name: '通过RiLineX，我们与合作伙伴为汽车工业、机械制造、船舶等各种领域的配电系统提供标准化解决方案'
        },
        {
          name: '创新的卡扣设计，可实现快速、高效的规划与安装，正面防接触保护达到IP2XB，可升级至IP4X'
        },
        {
          name: 'RilineX适配器全面升级，满足IEC61439和UL508标准，灵活适配多种电气元件的安装需求'
        },
      ]
    }
  }
])
const showText = (index: number) => {
  console.log(index)
  handles[index].hover = true // 鼠标移入，显示文字
  console.log(handles[index].hover)
}

const hideText = (index: number) => {
  handles[index].hover = false // 鼠标移出，隐藏文字
}
// 计算当前选中的手柄对象
const currentHandle = computed(() => {
  return currentHandleIndex.value !== null ? handles[currentHandleIndex.value] : null
})

// 点击手柄时，记录索引并显示 Dialog
function handleClick (index: number) {
  srcList.value = []
  currentHandleIndex.value = index
  dialogVisible.value = true
  title.value = handles[index].name // 设置标题为当前手柄名称
  srcList.value.push(handles[index].detail.img)
  if (handles[index].detail.imgs) {
    srcList.value.push(handles[index].detail.imgs)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("video", {
        autoplay: "",
        loop: "",
        muted: "",
        playsinline: "",
        "webkit-playsinline": "",
        preload: "auto",
        class: "video"
      }, [
        _createElementVNode("source", {
          src: _imports_0,
          type: "video/mp4"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(handles, (handle, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "handle-wrapper",
            onMouseenter: ($event: any) => (showText(index)),
            onMouseleave: ($event: any) => (hideText(index)),
            style: _normalizeStyle({ top: handle.top, left: handle.left })
          }, [
            (handle.hover)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  style: {"width":"51px","height":"50px"},
                  src: _imports_1,
                  alt: "",
                  onClick: ($event: any) => (handleClick(index))
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6)),
            _createElementVNode("div", {
              onClick: ($event: any) => (handleClick(index)),
              class: _normalizeClass([{visible:handle.hover}, "handle-label"]),
              style: _normalizeStyle([{"display":"flex","align-items":"center","cursor":"pointer"}, {transform: `translate(${handle.offsetX ?? '-50%'}, ${handle.offsetY ?? '-50%'})`}])
            }, [
              _createElementVNode("p", null, _toDisplayString(handle.name), 1),
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                style: {"margin-left":"10px","margin-top":"1px","width":"4px","height":"8px"},
                src: _imports_3,
                alt: ""
              }, null, -1))
            ], 14, _hoisted_7)
          ], 44, _hoisted_4))
        }), 128))
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "position" }, [
        _createElementVNode("h1", { class: "blink-effect" }, "数字化集成车间全景展示")
      ], -1)),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
        width: "70%",
        center: "",
        style: {"top":"0"},
        class: "dialog"
      }, {
        default: _withCtx(() => [
          (currentHandle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (currentHandle.value.detail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (currentHandle.value.detail.type !==0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_el_image, {
                                  style: {},
                                  src: currentHandle.value.detail.img,
                                  "zoom-rate": 1.2,
                                  "max-scale": 7,
                                  "min-scale": 0.2,
                                  "initial-index": 4,
                                  fit: "cover"
                                }, null, 8, ["src"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (currentHandle.value.detail.img !=='')
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 0,
                                      style: {},
                                      src: currentHandle.value.detail.img,
                                      "zoom-rate": 1.2,
                                      "max-scale": 7,
                                      "min-scale": 0.2,
                                      "initial-index": 4,
                                      fit: "cover"
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true),
                                _cache[6] || (_cache[6] = _createElementVNode("video", {
                                  width: "100%",
                                  preload: "auto",
                                  autoplay: "",
                                  loop: "",
                                  muted: "",
                                  playsinline: "",
                                  "webkit-playsinline": ""
                                }, [
                                  _createElementVNode("source", {
                                    src: _imports_4,
                                    type: "video/mp4"
                                  })
                                ], -1))
                              ])),
                          (currentHandle.value.detail.list)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                                _createElementVNode("li", _hoisted_15, _toDisplayString(currentHandle.value.detail.title), 1),
                                (currentHandle.value.detail.subTitle && currentHandle.value.detail.subTitle!='')
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(currentHandle.value.detail.subTitle), 1))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentHandle.value.detail.list, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                    (item.children)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                                            return (_openBlock(), _createElementBlock("li", { key: childIndex }, _toDisplayString(child.name), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                _createElementVNode("ul", _hoisted_18, [
                                  (currentHandle.value.detail.lists)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(currentHandle.value.detail.lists, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.name), 1))
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ]),
                                (currentHandle.value.detail.type !==0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                      (currentHandle.value.detail.url !=='')
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            class: "defult",
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickPlay(currentHandle.value.detail.url)))
                                          }, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                              _createTextVNode("观看视频 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (currentHandle.value.detail.urls !=='')
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 1,
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (clickPlay(currentHandle.value.detail.urls))),
                                            style: {"background":"rgb(229,0,67)","color":"#fff"}
                                          }, {
                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                              _createTextVNode("样本下载 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (currentHandle.value.detail2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (currentHandle.value.detail2.type !==0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_component_el_image, {
                                  style: {},
                                  src: currentHandle.value.detail2.img,
                                  "zoom-rate": 1.2,
                                  "max-scale": 7,
                                  "min-scale": 0.2,
                                  "initial-index": 4,
                                  fit: "cover"
                                }, null, 8, ["src"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (currentHandle.value.detail2.img !=='')
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 0,
                                      style: {},
                                      src: currentHandle.value.detail2.img,
                                      "zoom-rate": 1.2,
                                      "max-scale": 7,
                                      "min-scale": 0.2,
                                      "initial-index": 4,
                                      fit: "cover"
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true),
                                _cache[9] || (_cache[9] = _createElementVNode("video", {
                                  width: "100%",
                                  preload: "auto",
                                  autoplay: "",
                                  loop: "",
                                  muted: "",
                                  playsinline: "",
                                  "webkit-playsinline": ""
                                }, [
                                  _createElementVNode("source", {
                                    src: _imports_4,
                                    type: "video/mp4"
                                  })
                                ], -1))
                              ])),
                          (currentHandle.value.detail2.list)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                                _createElementVNode("li", _hoisted_24, _toDisplayString(currentHandle.value.detail2.title), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentHandle.value.detail2.list, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                    (item.children)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                                            return (_openBlock(), _createElementBlock("li", { key: childIndex }, _toDisplayString(child.name), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                _createElementVNode("ul", _hoisted_26, [
                                  (currentHandle.value.detail2.lists)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(currentHandle.value.detail2.lists, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.name), 1))
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ]),
                                (currentHandle.value.detail2.type !==0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                      (currentHandle.value.detail2.url !=='')
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            class: "defult",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (clickPlay(currentHandle.value.detail2.url)))
                                          }, {
                                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                              _createTextVNode("观看视频 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (currentHandle.value.detail2.urls !=='')
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 1,
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (clickPlay(currentHandle.value.detail2.urls))),
                                            style: {"background":"rgb(229,0,67)","color":"#fff"}
                                          }, {
                                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                                              _createTextVNode("样本下载 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})